import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Network, TrendingUp, FileText } from 'lucide-react';
import DarkHeader from './common/DarkHeader';

function MyReportsPage({ onBack, onNavigateToNetworkConsumption, onNavigateToCfoBurn, onLogout, onSettings }) {
    return (
        <div className="page-container">
            {/* Background blur effects */}
            <div className="bg-blur-indigo"></div>
            <div className="bg-blur-fuchsia"></div>
            
            <DarkHeader
                title="My Reports"
                subtitle="View and analyze your performance reports"
                showBackButton={false}
            />

            <Container fluid style={{ position: 'relative', zIndex: 10 }}>
                <Row className="g-4">
                    {/* Network Consumption */}
                    <Col md={6}>
                        <div 
                            className="glass dashboard-card-glass"
                            style={{
                                padding: '1.5rem',
                                borderRadius: '1.5rem',
                                cursor: 'pointer',
                                height: '100%',
                                textAlign: 'center'
                            }}
                            onClick={onNavigateToNetworkConsumption}
                        >
                            <div style={{ marginBottom: '1rem' }}>
                                <div style={{
                                    padding: '0.75rem',
                                    background: 'rgba(59, 130, 246, 0.2)',
                                    borderRadius: '0.75rem',
                                    color: '#60a5fa',
                                    display: 'inline-block'
                                }}>
                                    <Network size={48} />
                                </div>
                            </div>
                            <h3 className="theme-text" style={{ fontSize: '1.25rem', fontWeight: 'bold', margin: 0 }}>
                                Network Consumption
                            </h3>
                        </div>
                    </Col>
                    
                    {/* Full CFO Burn */}
                    <Col md={6}>
                        <div 
                            className="glass dashboard-card-glass"
                            style={{
                                padding: '1.5rem',
                                borderRadius: '1.5rem',
                                cursor: 'pointer',
                                height: '100%',
                                textAlign: 'center'
                            }}
                            onClick={onNavigateToCfoBurn}
                        >
                            <div style={{ marginBottom: '1rem' }}>
                                <div style={{
                                    padding: '0.75rem',
                                    background: 'rgba(168, 85, 247, 0.2)',
                                    borderRadius: '0.75rem',
                                    color: '#a78bfa',
                                    display: 'inline-block'
                                }}>
                                    <TrendingUp size={48} />
                                </div>
                            </div>
                            <h3 className="theme-text" style={{ fontSize: '1.25rem', fontWeight: 'bold', margin: 0 }}>
                                Full CFO Burn
                            </h3>
                        </div>
                    </Col>
                    
                    {/* Placeholder 1 */}
                    <Col md={6}>
                        <div 
                            className="glass"
                            style={{
                                padding: '1.5rem',
                                borderRadius: '1.5rem',
                                height: '100%',
                                textAlign: 'center',
                                opacity: 0.5,
                                cursor: 'not-allowed'
                            }}
                        >
                            <div style={{ marginBottom: '1rem' }}>
                                <div style={{
                                    padding: '0.75rem',
                                    background: 'rgba(107, 114, 128, 0.2)',
                                    borderRadius: '0.75rem',
                                    color: '#9ca3af',
                                    display: 'inline-block'
                                }}>
                                    <FileText size={48} />
                                </div>
                            </div>
                            <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#9ca3af', margin: 0 }}>
                                Coming Soon
                            </h3>
                        </div>
                    </Col>
                    
                    {/* Placeholder 2 */}
                    <Col md={6}>
                        <div 
                            className="glass"
                            style={{
                                padding: '1.5rem',
                                borderRadius: '1.5rem',
                                height: '100%',
                                textAlign: 'center',
                                opacity: 0.5,
                                cursor: 'not-allowed'
                            }}
                        >
                            <div style={{ marginBottom: '1rem' }}>
                                <div style={{
                                    padding: '0.75rem',
                                    background: 'rgba(107, 114, 128, 0.2)',
                                    borderRadius: '0.75rem',
                                    color: '#9ca3af',
                                    display: 'inline-block'
                                }}>
                                    <FileText size={48} />
                                </div>
                            </div>
                            <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#9ca3af', margin: 0 }}>
                                Coming Soon
                            </h3>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default MyReportsPage;
